module.exports = __webpack_public_path__ + "static/img/13areaA_5.593e8a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/13areaA_5.png
// module id = 1004
// module chunks = 1